import { peopleRef } from "@/vue-service-database.js";
import { getPersonsPushId } from "@/vue-service-selected_person.js";
import store from "@/store";

function updatePersonInfo(email, allInfo){
	let id = getPersonsPushId(email);
	peopleRef.child(id).set(allInfo);
	peopleRef.child(id).once("value", snapshot => {
		let updatedPerson = snapshot.val();
		let updatedPeople = Object.assign({}, store.getters.people);
		updatedPeople[id] = updatedPerson;
		store.dispatch("SET_PEOPLE", updatedPeople);
	});
}
// example function for updating data client-side...
// function addFullName(email) {
// 	let id = getPersonsPushId(email);
// 	let personRef = peopleRef.child(id);
// 	var name = "";
// 	personRef.once("value", item => {
// 		let i = item.val();
// 		name = i.fName.toLowerCase() + i.lName.toLowerCase();
// 	});
// 	personRef.update({
// 		"fullName": name
// 	});
// }

export {
	updatePersonInfo,
	addFullName
};


// WEBPACK FOOTER //
// ./src/vue-service-person.js